import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
// import { HistoryList } from '../interfaces/history';

@Injectable({
  providedIn: 'root'
})
export class HistoryService {
  private readonly openRequests = new Subject<void>();

  /** Emits every time something asks for the history accordion to be opened, see HistoryComponent */
  readonly openRequested$: Observable<void> = this.openRequests.asObservable();

  constructor() { }

  /** Opens the history accordion and scrolls to it, also when it was already opened and collapsed again */
  open(): void {
    this.openRequests.next();
  }
}
